import { useState } from 'react';
import Icon from '../../component/Icon';
import Inputbox from '../../component/Inputbox';
import { mapUrl } from '../Contact/Contact';

function Checkout() {
  const [paymentMethod, setPaymentMethod] = useState('cod');
  return (
    <div className='px-40 py-10'>
      <h2 className='text-4xl mb-8 text-center font-semibold font-SourceSerif text-darkPrimary'>
        Checkout
      </h2>
      <form>
        <h1 className='mb-4 text-2xl text-darkPrimary'>Personal Details</h1>
        <div className='flex gap-4 mb-4'>
          <Inputbox title='Fullname' placeholder='John Smith' />
          <Inputbox title='Phone Number' placeholder='9874578457' />
          <Inputbox title='Coupon code' placeholder='XYI12SER' />
        </div>
        <div className='mb-4'>
          <img
            src={mapUrl}
            className='block w-full h-[25rem] object-cover rounded-xl'
            alt='google maps'
          />
        </div>
        <textarea
          rows={10}
          className='border w-full border-greyLight mb-8 rounded-lg p-[1rem]'
          placeholder='Say something about your location...'
        ></textarea>

        <h2 className='mb-4 text-2xl text-darkPrimary'>Payment Gateway</h2>
        <PaymentGateway method={paymentMethod} setMethod={setPaymentMethod} />
        <h2 className='mt-16 mb-8 text-2xl text-darkPrimary'>Details</h2>
        {/* DETAILS */}
        <div className='flex justify-between gap-4'>
          <div className='flex-1'>
            <h2 className='flex gap-2 mb-3 text-darkPrimary font-light'>
              <span className='font-medium'>Fullname :</span>
              <span>John Doe</span>
            </h2>
            <h2 className='flex mb-3 gap-2 text-darkPrimary font-light'>
              <span className='font-medium'>Phone Number :</span>
              <span>9854784589</span>
            </h2>
            <h2 className='flex gap-2 text-darkPrimary font-light'>
              <span className='font-medium'>Delivery charges :</span>
              <span>Rs 50</span>
            </h2>
          </div>
          <div className='flex-1'>
            <h2 className='flex gap-2 mb-3 text-darkPrimary font-light'>
              <span className='font-medium'>Delivery location :</span>
              <span>Kathmandu , Samakhusi , Near nilo pool</span>
            </h2>
            <h2 className='flex mb-3 gap-2 text-darkPrimary font-light'>
              <span className='font-medium'>Payment method :</span>
              <span>Cash on delivery</span>
            </h2>
            <h2 className='flex gap-2 font-semibold text-darkPrimary'>
              <span>Total amount :</span>
              <span>Rs 5000</span>
            </h2>
          </div>
        </div>
        <button
          to='/checkout'
          className='flex p-2 hover:opacity-80 transition ease-out w-max px-4 uppercase mx-auto my-8  rounded-lg items-center gap-2 bg-greyPrimary'
        >
          <Icon name='tickBox' className='w-6 h-6 fill-white' />
          <h2 className='font-[600] text-white'>Place Order</h2>
        </button>
      </form>
    </div>
  );
}

function PaymentGateway(props) {
  return (
    <div className='flex gap-4'>
      <button
        type='button'
        onClick={() => props.setMethod('cod')}
        className={`rounded-lg hover:border-[3px] border-[3px] ${
          props.method === 'cod' ? 'border-green-400' : 'border-transparent'
        }  hover:border-green-400 p-4 bg-lightBlue flex items-center justify-center`}
      >
        <img
          src='./images/cashOnDelivery.png'
          className='block object-contain'
          alt='cod'
        />
      </button>
      <button
        type='button'
        onClick={() => props.setMethod('esewa')}
        className={`rounded-lg hover:border-[3px] border-[3px] ${
          props.method === 'esewa' ? 'border-green-400' : 'border-transparent'
        }  hover:border-green-400 p-4 bg-lightBlue flex items-center justify-center`}
      >
        <img
          src='./images/esewa.png'
          className='block object-contain'
          alt='cod'
        />
      </button>
      <button
        type='button'
        onClick={() => props.setMethod('khalti')}
        className={`rounded-lg hover:border-[3px] border-[3px] ${
          props.method === 'khalti' ? 'border-green-400' : 'border-transparent'
        }  hover:border-green-400 p-4 bg-lightBlue flex items-center justify-center`}
      >
        <img
          src='./images/khalti.png'
          className='block object-contain'
          alt='cod'
        />
      </button>
    </div>
  );
}
export default Checkout;
